import React from "react"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"

import logoWordmark from "src/assets/landing-v2/logo-wordmark.png"

// The site footer — the new-ui export's design, used on EVERY page.
// AirtagFooter now re-exports this, so all 27 pages that imported it get the
// new design without a call-site change.
// brand, then PRODUCTS / T&C / SUPPORT links | CONTACT US, then the legal line.
const footLink = { font: '700 12px \'Manrope\'', letterSpacing: '.16em', textTransform: 'uppercase', color: '#4A4463' }

const SiteFooter = () => {
    const { t } = useTranslation()

    return (
            <div className="atl2c" data-screen-label="Footer" style={{ padding: 'clamp(34px,3.6vw,52px) clamp(18px,3.4vw,48px) 28px', background: '#F7F6F9', borderTop: '1px solid #ECEAF2' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', paddingBottom: 'clamp(20px,2.2vw,30px)' }}>
                  <img src={logoWordmark} alt="Airtag" style={{ height: '40px', width: 'auto', maxWidth: '100%', alignSelf: 'flex-start', objectFit: 'contain', display: 'block' }} />
                  <span style={{ font: '700 15px \'Manrope\'', color: '#4A4463' }}>{t('landing.footTagline')}</span>
                </div>
                {/* Two columns at every width (client feedback, 14 Oct 2026): the links on the
                    left, CONTACT US on the right. */}
                <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0,0.85fr) minmax(0,1.5fr)', gap: 'clamp(18px,3vw,44px)', paddingBottom: 'clamp(26px,2.6vw,38px)' }}>
                  <nav style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <Link to="/products" style={footLink}>{t('landing.nav.products')}</Link>
                    <Link to="/privacy-policy" style={footLink}>{t('landing.foot_privacy')}</Link>
                    <Link to="/profile/support" style={footLink}>{t('landing.footSupport')}</Link>
                  </nav>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <span style={{ font: '700 12px \'Manrope\'', letterSpacing: '.16em', textTransform: 'uppercase', color: '#6B6485' }}>{t('landing.footContact')}</span>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#3C028D" strokeWidth="1.9" style={{ flex: '0 0 17px' }}><path d="M5 4h4l2 5-2.5 1.5a12 12 0 005 5L15 13l5 2v4a1.5 1.5 0 01-1.7 1.5C10.5 19.6 4.4 13.5 3.5 5.7A1.5 1.5 0 015 4z"></path></svg>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                        <a href="tel:1800881828" style={{ font: '700 17px \'Sora\'', color: '#14122B' }}>1800-88-1828</a>
                        <span style={{ font: '500 12px \'Manrope\'', color: '#6B6485' }}>{t('landing.tollFree')}</span>
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#3C028D" strokeWidth="1.9" style={{ flex: '0 0 17px' }}><rect x="3" y="5" width="18" height="14" rx="2"></rect><path d="M3.5 6.5L12 13l8.5-6.5"></path></svg>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', minWidth: '0' }}>
                        <a href="mailto:support@airtagcode.com" style={{ font: '600 clamp(12px,3.3vw,15px) \'Manrope\'', color: '#14122B', whiteSpace: 'nowrap' }}>support@airtagcode.com</a>
                        <span style={{ font: '500 12px \'Manrope\'', color: '#6B6485' }}>{t('landing.footEmailUs')}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '8px 24px', paddingTop: '22px', borderTop: '1px solid #E3E1E9' }}>
                  <span style={{ font: '500 12px \'Manrope\'', color: '#6B6485' }}>{t('landing.copyright', { year: new Date().getFullYear() })}</span>
                  <span style={{ font: '500 12px \'Manrope\'', color: '#6B6485' }}>{t('landing.footAdults')}</span>
                </div>
              </div>
    )
}

export default SiteFooter
